import { Component, OnInit } from '@angular/core';
import { documentMaster } from '../../../Models/DocumentMasterModel';
import { CheckAuth } from '../../../Services/UtilityService';
import { AdmindocumentMasterServices } from '../../../Services/Admin/DocumentMaster';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-manage-system-documents',
  templateUrl: './manage-system-documents.component.html',
  styleUrls: ['./manage-system-documents.component.css']
})
export class ManageSystemDocumentsComponent implements OnInit {
  tokenKey: string = '';
  documentMaster: documentMaster[] = [];
  statusCode: number = 0;
  totalPageSize: number = 0;
  pageSize: number = 0;
  pageIndex: number = 0;
  orderBy: string = 'null';
  whereCondition: string = 'null';
  deleteId: string = '0';
  isAscending: boolean;
  refreshTable: boolean = true;
  upDowTitleCSS: string = '';
  upDowTopicCSS: string = '';
  upDowTypeCSS: string = '';
  upDowDocumentTypeCSS: string = '';
  upDowCustomizedCSS: string = '';
  // Message 
  isErrorMessage: boolean = false;
  errorMessage: string = '';

  constructor(private checkAuth: CheckAuth, private toastr: ToastrService, private documentServices: AdmindocumentMasterServices) {
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));
  }
  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }
  ngOnInit() {
    debugger;
    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.refreshTable = true;
    this.pageSize = 10;
    this.totalPageSize = 1;
    this.pageIndex = 1;
    this.whereCondition = 'null';
    this.orderBy = 'Title';
    this.isAscending = false;
    this.GetDocumentMaster();
    this.showErrorMessage();
  }

  GetDocumentMaster(): void {
    this.documentServices.GetDocumentMasterFilterByPage(this.tokenKey, this.pageIndex.toString(), this.pageSize.toString(), this.whereCondition, this.orderBy).subscribe(
      data => {
        debugger;
        this.documentMaster = data["documents"];
        if (this.documentMaster.length > 0)
          this.totalPageSize = parseInt(this.documentMaster[0].totalRecords);
      },
      error => this.statusCode = error,
    );
  }

  showErrorMessage() {
    debugger;
    if (sessionStorage.getItem("IndustryCRUDStatus") !== null) {
      if (sessionStorage.getItem("IndustryCRUDStatus") === 'Added') {
        this.showMessage('Industry added successfully', 'Added', 'success');
        sessionStorage.removeItem('IndustryCRUDStatus');
      }
      else if (sessionStorage.getItem("IndustryCRUDStatus") === 'Edited') {
        this.showMessage('Industry updated successfully', 'Edited', 'success');
        sessionStorage.removeItem('IndustryCRUDStatus');
      }
    }
  }
  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }
  sort(sortBy: string) {
    debugger;

    if (!this.isAscending) {
      this.isAscending = true;
      this.orderBy = sortBy + ' DESC';

      if (sortBy === "Title") {
        this.upDowTitleCSS = 'fa fa-arrow-up';
        this.upDowTopicCSS = '';
        this.upDowTypeCSS = '';
        this.upDowDocumentTypeCSS = '';
        this.upDowCustomizedCSS = '';
      }
      else if (sortBy === "Topic") {
        this.upDowTitleCSS = '';
        this.upDowTopicCSS = 'fa fa-arrow-up';
        this.upDowTypeCSS = '';
        this.upDowDocumentTypeCSS = '';
        this.upDowCustomizedCSS = '';
      }
      else if (sortBy === "Type") {
        this.upDowTitleCSS = '';
        this.upDowTopicCSS = '';
        this.upDowTypeCSS = 'fa fa-arrow-up';
        this.upDowDocumentTypeCSS = '';
        this.upDowCustomizedCSS = '';
      }
      else if (sortBy === "DocumentType") {
        this.upDowTitleCSS = '';
        this.upDowTopicCSS = '';
        this.upDowTypeCSS = '';
        this.upDowDocumentTypeCSS = 'fa fa-arrow-up';
        this.upDowCustomizedCSS = '';
      }
      else if (sortBy === "IsCustomize") {
        this.upDowTitleCSS = '';
        this.upDowTopicCSS = '';
        this.upDowTypeCSS = '';
        this.upDowDocumentTypeCSS = '';
        this.upDowCustomizedCSS = 'fa fa-arrow-up';
      }
    }
    else {
      this.isAscending = false;
      this.orderBy = sortBy;

      if (sortBy === "Title") {
        this.upDowTitleCSS = 'fa fa-arrow-down';
        this.upDowTopicCSS = '';
        this.upDowTypeCSS = '';
        this.upDowDocumentTypeCSS = '';
        this.upDowCustomizedCSS = '';
      }
      else if (sortBy === "Topic") {
        this.upDowTitleCSS = '';
        this.upDowTopicCSS = 'fa fa-arrow-down';
        this.upDowTypeCSS = '';
        this.upDowDocumentTypeCSS = '';
        this.upDowCustomizedCSS = '';
      }
      else if (sortBy === "Type") {
        this.upDowTitleCSS = '';
        this.upDowTopicCSS = '';
        this.upDowTypeCSS = 'fa fa-arrow-down';
        this.upDowDocumentTypeCSS = '';
        this.upDowCustomizedCSS = '';
      }
      else if (sortBy === "DocumentType") {
        this.upDowTitleCSS = '';
        this.upDowTopicCSS = '';
        this.upDowTypeCSS = '';
        this.upDowDocumentTypeCSS = 'fa fa-arrow-down';
        this.upDowCustomizedCSS = '';
      }
      else if (sortBy === "IsCustomize") {
        this.upDowTitleCSS = '';
        this.upDowTopicCSS = '';
        this.upDowTypeCSS = '';
        this.upDowDocumentTypeCSS = '';
        this.upDowCustomizedCSS = 'fa fa-arrow-down';
      }
    }

    this.GetDocumentMaster();
  }
  refreshGrid(): void {
    this.refreshTable = false;
    setTimeout(() => {
      this.refreshTable = true;
      this.pageIndex = 1;
    }, 10);
  }
  pageChanged($event) {
    this.pageIndex = parseInt($event.page);
    this.GetDocumentMaster();
  }
}
